import { FC } from 'react';
import cn from 'classnames';
import { BLOCKS, MARKS } from '@contentful/rich-text-types';

import {
  Content,
  DataLink,
  Title,
} from 'components/Shared/SharedComponents';
import { SectionComponentInterface } from 'types/componentTypes';
import classes from 'src/styles/_commonClasses.module.scss';
import { capitalizeFirstLetter } from 'lib/text.service';
import { CommonSize } from 'constants/enums';
import type { Block } from 'src/__generated__/graphqlTypes';

import styles from './CustomizableMobileSlider.module.scss';
import { Blocks } from './Blocks';

const richTextConfig = {
  [BLOCKS.HEADING_2]: {
    classNames: cn(styles.title, styles.titleH2),
  },
  [BLOCKS.HEADING_3]: {
    classNames: cn(styles.title, styles.titleH3),
  },
  [BLOCKS.PARAGRAPH]: {
    classNames: cn(styles.paragraph, styles.paragraphAlignCenter),
  },
  [MARKS.BOLD]: {
    classNames: classes.textBold,
  },
};

const CustomizableMobileSlider: FC<SectionComponentInterface> = ({
  blocks,
  bgColor,
  extraData,
}) => {
  if (!blocks.length) {
    return null;
  }

  const [block] = blocks;
  const {
    verticalMargin = CommonSize.X_SMALL,
    verticalPadding = null,
  } = extraData || {};
  const { richTitle, content, link } = block;
  const contentBlocks = block.contentTypesCollection?.items as Array<Block>;

  return (
    <section
      className={
        cn(
          styles.wrapper,
          classes[`marginVertical${capitalizeFirstLetter(verticalMargin)}`],
          verticalPadding && classes[`sharedWrapperPaddingVertical${capitalizeFirstLetter(verticalPadding)}`],
        )
      }
      style={{ background: bgColor }}
    >
      <div className={styles.content}>
        <Title richText={richTitle} config={richTextConfig} />
        <Content richText={content} config={richTextConfig} />
        <Blocks blocks={contentBlocks} />
        {link && (
          <DataLink link={link} className={styles.link}>
            {link.title}
          </DataLink>
        )}
      </div>
    </section>
  );
};

export default CustomizableMobileSlider;
